import * as ApiManager from './_manager';

export const impersonation = {

    create: (payload) => {
        return ApiManager.callApi('/admin/user/impersonation/create', payload);
    },

    leave: (payload) => {
        return ApiManager.callApi('/admin/user/impersonation/leave', payload);
    }
}
